import { useContext } from "react";
import { AutoTableColumnContext } from "./auto-table-column-provider.constants";

const useAutoTableColumnContext = () => {
    const context = useContext(AutoTableColumnContext);
    if (context === undefined) {
        throw new Error("useAutoTableColumnContext must be used within a AutoTableColumnContext");
    }
    return context;
};

export { useAutoTableColumnContext };
